// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","title":"title-3mQW0","sortings":"sortings-1tF8r","sortBy":"sortBy-JE4iH","currentSorting":"currentSorting-zxRoc"};